/**
 * LandingRenderer — renders a block-based design (blocks + theme) as a full
 * public page: site Header, the ordered visible blocks, and a themed footer.
 * Used by the public homepage (when a non-classic design is active) and by the
 * CRM editor live preview.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Header';
import { BlockView } from './LandingBlocks';
import { resolveFontFamily } from '../../lib/fonts';

const MARQUEE_CSS = `@keyframes lp-scroll{from{transform:translateX(0)}to{transform:translateX(-33.333%)}}`;

export const LandingRenderer = ({ design, previewBlocks }) => {
  if (!design) return null;
  const theme = design.theme || {};
  const blocks = (previewBlocks || design.blocks || []).filter((b) => !b.hidden);
  const bf = resolveFontFamily(theme.body_font, '"Poppins", sans-serif');
  const hf = resolveFontFamily(theme.heading_font, '"Fredoka", sans-serif');
  return (
    <div style={{ background: theme.bg, color: theme.text, fontFamily: bf, minHeight: '100vh' }} data-testid="landing-renderer">
      <style>{MARQUEE_CSS}</style>
      <Header />
      <main>
        {blocks.map((b) => (
          <div key={b.id} data-block-type={b.type}>
            <BlockView block={b} theme={theme} />
          </div>
        ))}
      </main>
      <footer className="px-5 sm:px-8 lg:px-12 py-10" style={{ background: theme.surface, borderTop: `1px solid ${theme.text}12` }}>
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-extrabold text-lg" style={{ fontFamily: hf, color: theme.text }}>Creative Birthdays</span>
          <div className="flex flex-wrap gap-5 text-sm" style={{ color: theme.muted }}>
            <Link to="/book" className="hover:underline">Book a Party</Link>
            <Link to="/contact" className="hover:underline">Contact</Link>
            <Link to="/gift-cards" className="hover:underline">Gift Cards</Link>
            <Link to="/loyalty-program" className="hover:underline">Rewards</Link>
          </div>
          <span className="text-xs" style={{ color: theme.muted }}>© {new Date().getFullYear()} Creative Birthdays</span>
        </div>
      </footer>
    </div>
  );
};

export default LandingRenderer;
